import React, { useMemo } from 'react'
import Box from '@mui/material/Box'
import { orange } from '@mui/material/colors'

import { ActionCardProps } from 'types/TextAnalysis'
import { StyledTypography } from '../Helper'
import { highlightKeyPhrases } from './HighlightContent'

const CardContentDesc = ({
  cardContent,
  highlightKeyPhrases: keyPhrases,
}: ActionCardProps) => {
  if (!cardContent) return null

  const processedContent = useMemo(() => {
    return typeof cardContent === 'string' && keyPhrases?.length
      ? highlightKeyPhrases(cardContent, keyPhrases)
      : cardContent
  }, [cardContent, keyPhrases])

  return (
    <Box
      id="card-content"
      data-testid="card-content-id"
      sx={{
        pt: 2,
        '& .highlight': {
          px: '2px',
          borderRadius: 0.5,
          border: `1.5px solid ${orange[500]}`,
        },
      }}
    >
      {typeof processedContent === 'string' ? (
        <StyledTypography
          variant="body"
          dangerouslySetInnerHTML={{
            __html: processedContent,
          }}
        />
      ) : (
        processedContent
      )}
    </Box>
  )
}

export { CardContentDesc }
